export class TechnicianOrder{
    TechnicianOrderId: any;
    WarehouseId: any;
    OrderDate: any;
    OrderPriority: any;
}